//state
export var audienciaState = {
    audiencias: [],
    audiencia: {},
    status_audiencia: ""
  };
  
  //getters
  export var audienciaGetters = {
    //funciones para optener informacion del state
    getAudiencias: state => state.audiencias
  };
  //,"pixel_id","account_id",
  
  //actions
  export var audienciaActions = {
    async getAudiencias({ commit }) {
      commit("audiencia_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.adset.targeting.audience", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields: '["code","name","display_name","id","subtype","is_value_based","raw_rule","retention_days",("country_id", ["id", "name"]),("parent_id", ["id", "name"]),("pixel_id", ["id", "name"]),("account_id", ["id", "name"])]'
          }
        })
        .then(res => {
          var audiencias = res.data;
          commit("audiencia_success", audiencias);
          return res;
        })
        .catch(err => {
          commit("audiencia_error");
          return err;
        });
    },
    async newAudiencia({ commit, state }, audiencia) {
      commit("audiencia_request");
      var {
        name,
        code,
        ad_account,
        pixel,
        subtype,
        is_value_based,
        raw_rule,
        country,
        retention_days,
        parent_id,

      } = audiencia;
      var account_id = ad_account.id;
      var pixel_id = pixel.id
      var country_id = country.id
      var formData = new FormData();
      var newPartner = `{
        'name':'${name}',
        'code':'${code}',
        'subtype': '${subtype.value}',
        'raw_rule': '${raw_rule}',
        'retention_days': ${retention_days},
        'is_value_based': '${is_value_based}',
        'account_id': '${account_id}',
        'pixel_id': '${pixel_id}',
        'country_id': '${country_id}'
      }`;
      formData.append("data", newPartner);
      await this._vm.$http
        .post("/apache/rest_api/apache.adset.targeting.audience", formData, {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
          }
        })
        .then(res => {
          if (res.status == 201) {
            audiencia.id = res.data.id;
            audiencia.subtype = audiencia.subtype.value
            var audiencias = state.audiencias;
            audiencias.push(audiencia);
            commit("audiencia_success", audiencias);
            return audiencias;
          } else {
            commit("audiencia_error");
          }
        })
        .catch(err => {
          commit("audiencia_error");
          return err;
        });
    },
    async editAudiencia({ commit, state }, audiencia) {
      commit("audiencia_request");
      var {
        id,
        name,
        code,
        ad_account,
        pixel,
        subtype,
        is_value_based,
        raw_rule,
        country,
        retention_days,
        parent_id,
      } = audiencia;
      var account_id = ad_account.id;
      var pixel_id = pixel.id
      var country_id = country.id
      var formData = new FormData();
      var newPartner = `{
        'name':'${name}',
        'code':'${code}',
        'subtype': '${subtype.value}',
        'raw_rule': '${raw_rule}',
        'retention_days': ${retention_days},
        'is_value_based': '${is_value_based}',
        'account_id': '${account_id}',
        'pixel_id': '${pixel_id}',
        'country_id': '${country_id}'
      }`;
      formData.append("data", newPartner);
      await this._vm.$http
        .put("/apache/rest_api/apache.adset.targeting.audience", formData, {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
          },
          params: {
            ids: `[${id}]`
          }
        })
        .then(res => {
          if (res.status == 200) {
            var index;
            audiencia.id = res.data.id;
            audiencia.subtype = audiencia.subtype.value
            var audiencias = state.audiencias;
          for (var i = 0; i < audiencias.length; i++) {
            if (audiencias[i].id == id) {
              index = i;
              audiencias[i] = audiencia;
              break;
            }
          }
          audiencias.splice(index, 1);
          audiencias.splice(index, 0, audiencia);
          commit("audiencia_success", audiencias);
            return audiencias;
          } else {
            commit("audiencia_error");
          }
        })
        .catch(err => {
          commit("audiencia_error");
          return err;
        });
    },
    async deleteAudiencia({ commit, state }, id) {
      commit("audiencia_request");
      try {
        await this._vm.$http
          .delete(`/apache/rest_api/apache.adset.targeting.audience/${id}`, {
            headers: {
              "X-Odoo-dbfilter": "apachev1"
            }
          })
          .then(res => {
            if (res.status == 210) {
              var index;
              var audiencias = state.audiencias;
              for (var i = 0; i < audiencias.length; i++) {
                if (audiencias[i].id == id) {
                  index = i;
                  break;
                }
              }
              audiencias.splice(index, 1);
              commit("audiencia_success", audiencias);
  
              return audiencias;
            } else {
              commit("audiencia_error");
            }
          })
          .catch(err => {
            commit("audiencia_error");
            return err;
          });
      } catch (error) {
        console.log(error);
      }
    },
    async deleteAudienciaUtility({ commit, state }, id) {
      commit("audiencia_request");
      var index;
      var audiencias = state.audiencias;
      for (var i = 0; i < audiencias.length; i++) {
        if (audiencias[i].id == id) {
          index = i;
          break;
        }
      }
      audiencias.splice(index, 1);
      commit("audiencia_success", audiencias);
  
      return audiencias;
    }
  };
  
  //mutations
  
  export var audienciaMutations = {
    audiencia_request(state) {
      state.status_audiencia = "loading";
    },
    audiencia_success(state, payload) {
      state.status_audiencia = "success";
      state.audiencias = payload;
    },
    audiencia_error(state) {
      state.status_audiencia = "error";
    }
  };
  